import { useRef } from 'react';
import { useStickyHeader } from '../header/useStickyHeader';

const KEY_CODE_ENTER = 'Enter';
const KEY_CODE_ARROW_UP = 'ArrowUp';
const KEY_CODE_ARROW_DOWN = 'ArrowDown';

export function useHandleArrowKeySuggestionNavigation() {
    let suggestionKeyNavIndex = useRef(-1);
    let isLastInputArrowKey = useRef(false);
    const { isSticky } = useStickyHeader();

    return (e: KeyboardEvent) => {
        const headerClass = isSticky ? '.header-sticky' : '.header-main';
        const navElements = document.querySelectorAll(`${headerClass} .suggestion-arrow-nav`);
        const [container] = document.querySelectorAll('.search-suggestions');
        const containerRect = container ? container.getBoundingClientRect() : null;
        let scrollDist: number | null = null;
        let nextIndex: number | null = null;

        if (navElements.length > 0) {
            const keyCode = e.key;

            if (keyCode === KEY_CODE_ENTER) {
                if (isLastInputArrowKey.current && suggestionKeyNavIndex.current > -1) {
                    e.preventDefault();

                    const selectedElement = navElements[suggestionKeyNavIndex.current];
                    // topHit Result
                    const suggestionLink =
                        selectedElement.querySelector('.th-a') || selectedElement.querySelector('.packshot a');

                    const clickEvent = new MouseEvent('click', {
                        view: window,
                        bubbles: true,
                        cancelable: false
                    });
                    suggestionLink?.dispatchEvent(clickEvent);
                }
                suggestionKeyNavIndex.current = -1;
            }

            if (keyCode === KEY_CODE_ARROW_UP || keyCode === KEY_CODE_ARROW_DOWN) {
                isLastInputArrowKey.current = true;
            } else {
                isLastInputArrowKey.current = false;
                suggestionKeyNavIndex.current = -1;
            }

            navElements.forEach(navElement => {
                navElement.className = navElement.className.replace(' selected', '');
            });

            if (keyCode === KEY_CODE_ARROW_UP && suggestionKeyNavIndex.current !== -1 && containerRect) {
                nextIndex = suggestionKeyNavIndex.current - 1;

                if (navElements[nextIndex] && navElements[nextIndex].getBoundingClientRect().top < containerRect.top) {
                    scrollDist = navElements[nextIndex].getBoundingClientRect().top - containerRect.top;
                }
            } else if (keyCode === KEY_CODE_ARROW_DOWN) {
                if (suggestionKeyNavIndex.current + 1 < navElements.length && containerRect) {
                    nextIndex = suggestionKeyNavIndex.current + 1;
                    if (navElements[nextIndex].getBoundingClientRect().bottom > containerRect.bottom) {
                        scrollDist = navElements[nextIndex].getBoundingClientRect().bottom - containerRect.bottom;
                    }
                } else if (suggestionKeyNavIndex.current + 1 === navElements.length) {
                    navElements[suggestionKeyNavIndex.current].className += ' selected';
                }
            }

            if (nextIndex !== null) {
                if (nextIndex !== -1) {
                    navElements[nextIndex].className += ' selected';
                    if (scrollDist !== null) {
                        container.scrollTop = container.scrollTop + scrollDist;
                    }
                    e.preventDefault();
                } else {
                    if (suggestionKeyNavIndex.current === 0) {
                        const searchField = document.querySelector('.search-form input') as HTMLInputElement;
                        const caretPos = searchField.value.length;
                        if (searchField.selectionStart) {
                            searchField.focus();
                            searchField.setSelectionRange(caretPos, caretPos);
                        } else {
                            searchField.focus();
                        }
                        e.preventDefault();
                    }
                }

                suggestionKeyNavIndex.current = nextIndex;
            }
        }
    };
}
